const MechDataCol = [
  {
    id: 'id',
    numeric: false,
    disablePadding: true,
    label: 'ID',
  },
  {
    id: 'garage_name',
    numeric: false,
    disablePadding: true,
    label: 'Garage Name',
  },
  {
    id: 'name',
    numeric: false,
    disablePadding: false,
    required: true,
    label: 'Mechanic Name',
  },
  {
    id: 'email',
    numeric: false,
    disablePadding: false,
    label: 'Email',
  },
  {
    id: 'contact_number',
    numeric: false,
    disablePadding: false,
    required: true,
    label: 'Phone',
  },
  {
    id: 'gst_number',
    numeric: false,
    disablePadding: false,
    label: 'GST Number',
  },
  {
    id: 'pan_number',
    numeric: false,
    disablePadding: false,
    label: 'PAN Number',
  },
  {
    id: 'aadhar_number',
    numeric: false,
    disablePadding: false,
    label: 'Aadhaar Number',
  },
  {
    id: 'password',
    numeric: false,
    disablePadding: false,
    required: true,
    label: 'Password',
  },
  {
    id: 'bank_name',
    numeric: false,
    disablePadding: false,
    required: true,
    label: 'Bank',
  },
  {
    id: 'account_number',
    numeric: false,
    disablePadding: false,
    required: true,
    label: 'Account Number',
  },
  {
    id: 'ifsc_code',
    numeric: false,
    disablePadding: false,
    required: true,
    label: 'IFSC Code',
  },
  {
    id: 'address',
    numeric: false,
    disablePadding: false,
    required: true,
    label: 'Postal Address',
  },
  {
    id: 'state_name',
    numeric: false,
    disablePadding: false,
    required: true,
    label: 'State',
  },
  {
    id: 'state',
    numeric: false,
    disablePadding: false,
    required: true,
    label: 'State',
  },
  {
    id: 'city',
    numeric: false,
    disablePadding: false,
    required: true,
    label: 'City',
  },
  {
    id: 'pin_code',
    numeric: false,
    disablePadding: false,
    label: 'Pin Code',
  },
  {
    id: 'total_points',
    numeric: true,
    disablePadding: false,
    label: 'Total Points',
  },
  {
    id: 'avaiable_points',
    numeric: true,
    disablePadding: false,
    label: 'Avaiable Points',
  },
  {
    id: 'is_active',
    numeric: false,
    disablePadding: false,
    label: 'Is Active',
  },
  {
    id: 'actions',
    numeric: false,
    disablePadding: false,
    label: 'Actions',
  },
];

export default MechDataCol;
